import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProductMedia } from '../models/product-media.model';
import { ProductsBackend } from '../models/products.model';
import { ProductsService } from '../services/product/product.services';
import { ValueConverterService } from '../services/util/value-converter.service';
import BigNumber from 'bignumber.js';
import { CategoriesService } from '../services/categories/categories.service';
import { CategoryItem } from '../models/category-item.model';
import { TypeAssociatedProd } from '../models/category-type.enum';
import { ConfigReaderService } from '../services/util/config.reader.service';
import { UtilService } from '../services/util/util.service';

@Component({
    selector: 'app-recommended-products',
    templateUrl: './recommended-products.component.html',
    styleUrls: ['./recommended-products.component.scss']
})
export class RecommendedProductsComponent implements OnInit {

    @Input() public recommended: Array<ProductsBackend> = [];
    public quote: BigNumber;

    public hideAdvertisementPrice: boolean = false;
    public categories: Array<CategoryItem> = [];

    constructor(
        private readonly router: Router,
        private readonly productsService: ProductsService,
        private readonly categoriesService: CategoriesService,
        private readonly valueConverter: ValueConverterService, // used on HTML file
        private readonly configReaderService: ConfigReaderService
    ) { }

    public ngOnInit(): void {
        this.checkIfNeedFavorite();

        this.categoriesService.getCategories().subscribe(categories => {
            this.categories = categories;
        });

        this.configReaderService.getKairosConfig().subscribe(kairosConfigs => {
            this.hideAdvertisementPrice = kairosConfigs?.hideAdvertisementPrice;
        });
    }

    public checkIfNeedFavorite(): void {
        const hasProductId = this.productsService.getProductIdFromStorage();
        /**
         *  If there is a productId in the storage, it means that the user tried to favorite a product before being logged in,
         *  so we need to perform the favorite action after logging in.
         */
        if (hasProductId) {
            this.toggleFavorite(hasProductId, true);
        }
    }

    public toggleFavorite(productId: string, avoidRemoving: boolean = false): void {
        const productIndex = this.recommended.findIndex(product => product.id === productId);
        const product = this.recommended[productIndex];

        if (!product || (avoidRemoving && (product?.favorites?.length > 0))) {
            return;
        }

        const addFavorite: boolean = (product?.favorites?.length === 0);

        this.productsService.toggleFavoriteProduct(product?.id, addFavorite, this.router.url).subscribe((response: boolean) => {
            if (response) {
                if (addFavorite) {
                    this.recommended[productIndex].isFavorite = true;
                    this.recommended[productIndex].favorites.push({});
                } else {
                    this.recommended[productIndex].isFavorite = false;
                    this.recommended[productIndex].favorites.pop();
                }
            }
        });
    }

    public goToDetails(productId: string): void {
        window.location.href = `product-details/${productId}`;
    }

    public getProductImage(medias: Array<ProductMedia>): string {
        return UtilService.getExhibitionMediaData(medias);
    }

    public isAdvertisement(product: ProductsBackend): boolean {
        let category: CategoryItem = undefined;
        if (product?.values["subcategoryChild"]) {
            category = this.categories.find(cat => cat.id === product?.values["subcategoryChild"])
        } else if (product?.values["subcategoryParent"]) {
            category = this.categories.find(cat => cat.id === product?.values["subcategoryParent"])
        } else {
            category = this.categories.find(cat => cat.id === product?.category_id)
        }

        return category?.type_associated_prod === TypeAssociatedProd.ANNOUNCE;
    }
}
